<script>
import { createEventDispatcher } from "svelte";

export let value
export let doubleSpace = false
export let exact = []
export let contains = []
export let trash = []

const dispatch = createEventDispatcher()
function buttonClick() {
  dispatch('input', value)
}

let letterStatus = ''

$: if (exact.includes(value)) {
  letterStatus = 'bg-green-600'
} else if (contains.includes(value)) {
  letterStatus = 'bg-yellow-500'
} else if (trash.includes(value)) {
  letterStatus = 'bg-gray-300'
} else {
  letterStatus = 'bg-gray-500'
}
</script>

<div class={`uppercase rounded-sm text-gray-200 py-3 cursor-pointer animate-shake${doubleSpace ? ' col-span-2' : ''} ${letterStatus}`} on:click={buttonClick}>{ value }</div>
<div class="hidden bg-gray-300 bg-gray-500 bg-green-600 bg-yellow-500"></div>